import { render, staticRenderFns } from "./RatingAverage.vue?vue&type=template&id=9c8ee99a&scoped=true&"
import script from "./RatingAverage.vue?vue&type=script&lang=ts&"
export * from "./RatingAverage.vue?vue&type=script&lang=ts&"
import style0 from "./RatingAverage.vue?vue&type=style&index=0&id=9c8ee99a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8ee99a",
  null
  
)

export default component.exports